import React, { useEffect, useState } from 'react';
import { Box, Typography, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { AppSelect } from './InputComponents';
import { AppTextField } from '../components/InputComponents';
import { arrayOfNumbers } from '../../../services/util.service';
import useStyles from "./ChildrenLoss.style";
import multiItemQuestion from './MultiItemQuestion.component';
import { MobileButton } from '../../../components/MobileButton';
import { useTranslation } from 'react-i18next';

const ChildrenLoss = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [autoUpdate, setAutoUpdate] = useState(false);

    let birthYear = new Date(props.dateOfBirth).getFullYear();
    let firstPeriodAge = parseInt(props.firstPeriodAge);
    let firstPeriodYear = firstPeriodAge ? birthYear + firstPeriodAge : null;
    let currentYear = new Date(Date.now()).getFullYear();
    let lossYears = firstPeriodYear
        ? [...arrayOfNumbers(firstPeriodYear, currentYear - firstPeriodYear + 1)]
        : [];

    useEffect(() => {
        props.validator.purgeFields();
        setAutoUpdate(!autoUpdate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.items]);

    return (
        <Box className={classes.root}>
            {/* Header */}
            <Typography variant="h4" className={classes.title}>Have you suffered the loss of a child after birth?</Typography>
            <Typography className={classes.subTitle}>
            </Typography>
            {props.error && !props.validator.allValid() &&
                <Typography color="error">
                    Please review your answers
                </Typography>
            }
            {props.items.map((loss, i) =>
                <Box className={classes.item} key={i}>
                    <Box className={classes.itemHeader}>
                        <span>{t('repliQuestionnaire.label.childrenLoss')} #{i + 1}</span>
                        <IconButton aria-label="delete" color="inherit" onClick={props.onRemove(i)}>
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                    <Box className={classes.itemBody}>
                        <Box className={classes.inputSection}>
                            <Typography variant="h5">
                            
                                How many children have you lost?
                                {
                              <span className={props.error && !props.validator.fieldValid(`children_loss_#${i + 1}`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                                </Typography>
                            <AppTextField
                                variant="outlined"
                                label={`${t('repliQuestionnaire.label.childrenLoss')}*`}
                                type="number"
                                fullWidth
                                min="0"
                                inputProps={{ style: { textAlign: 'center' } }}
                                value={loss.childrenQty && Math.max(0, loss.childrenQty)}
                                onChange={props.onChange(i, 'childrenQty')}
                                error={props.error && !props.validator.fieldValid(`children_loss_#${i + 1}`)}
                                helperText={props.validator.message(`children_loss_#${i + 1}`, loss.childrenQty, 'required')}
                            />
                        </Box>
                        <Box className={classes.inputSection}>
                            <Typography variant="h5">
                            
                                When did it happen?
                                {
                              <span className={props.error && !props.validator.fieldValid(`children_loss_#${i + 1}_year`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                                </Typography>
                            <AppSelect
                                id={`loss${i + 1}`}
                                label={`${t('common.substantive.year')}*`}
                                value={loss.year}
                                items={lossYears}
                                onChange={props.onChange(i, 'year')}
                                fullWidth
                                error={props.error && !props.validator.fieldValid(`children_loss_#${i + 1}_year`)}
                                helperText={props.validator.message(`children_loss_#${i + 1}_year`, loss.year, 'required')}
                            />
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onAdd}
                color="primary"
                label="Add Children Loss"
                endIcon={<AddIcon />}
            />
        </Box>
    );
};

export default multiItemQuestion(
    ChildrenLoss,
    {
        year: '',
        childrenQty: ''
    });
